import { Component, Input, OnInit } from '@angular/core';
import {
  PastWorkshopModel,
  WorkshopHoldingTimeModel,
} from '../../../features/held-workshop/models/past-workshop.model';
import { ProfileService } from '../../../features/profile/services/profile.service';
import { NotifierService } from 'angular-notifier';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';

@Component({
  selector: 'app-past-workshop-card',
  templateUrl: './past-workshop-card.component.html',
  styleUrls: ['./past-workshop-card.component.css'],
  standalone: false,
})
export class PastWorkshopCardComponent implements OnInit {
  @Input() workshop: PastWorkshopModel;

  showContentsDialog: boolean = false;
  selectedContents: any[] = [];

  constructor(
    private profileService: ProfileService,
    private notifierService: NotifierService,
    private persianTitlesService: PersianTitlesService,
  ) {}

  ngOnInit(): void {}

  openContentsDialog(workshop: PastWorkshopModel): void {
    if (this.isContentsDownloadAllowed(workshop)) {
      this.selectedContents = workshop.contents;
      this.showContentsDialog = true;
    } else {
      this.notifierService.notify(
        'error',
        this.persianTitlesService.Phrases
          .MustCompleteSurveyToReceiveWorkshopContents,
      );
    }
  }

  downloadContent(content: any): void {
    this.profileService.downloadContent(content).subscribe(
      (blob) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = content.file_name;
        link.click();
      },
      () => {
        this.notifierService.notify('error', 'خطا در دانلود محتوا');
      },
    );
  }

  markContentsDownloadAsAllowed(workshop: PastWorkshopModel) {
    let visitedPastWorkshopSurveys: number[] =
      JSON.parse(localStorage.getItem('visitedPastWorkshopSurveys')) || [];
    visitedPastWorkshopSurveys.push(workshop.id);
    localStorage.setItem(
      'visitedPastWorkshopSurveys',
      JSON.stringify(visitedPastWorkshopSurveys),
    );
  }

  isContentsDownloadAllowed(workshop: PastWorkshopModel): boolean {
    if (!workshop.surveyLink || !workshop.holdingTimes.at(-1)) {
      return true;
    }
    const lastHoldingTimeEndDatetime = new Date(
      workshop.holdingTimes.at(-1).endDatetime,
    );
    const now = new Date();
    const timeGapInHours = Math.floor(
      (now.getTime() - lastHoldingTimeEndDatetime.getTime()) / 3600000,
    );
    if (timeGapInHours >= 24) {
      return true;
    }
    let visitedPastWorkshopSurveys: number[] =
      JSON.parse(localStorage.getItem('visitedPastWorkshopSurveys')) || [];
    return visitedPastWorkshopSurveys.includes(workshop.id);
  }

  concatTimes(holdingTimes: WorkshopHoldingTimeModel[]) {
    return holdingTimes?.map((e) => e.jalaliString).join(' | ');
  }

  formatMinutesToTime(total_minutes: number) {
    const hours = Math.floor(total_minutes / 60);
    const minutes = total_minutes % 60;
    return `${hours}:${String(minutes).padStart(2, '0')}`;
    // return `${hours}`;
  }
}
